import { StyledCheckArea } from './CheckArea.style';
import CheckIcon from '../../../../../images/icons/checkmark.svg';

const CheckArea = ({ isCheck }) => {
  return <StyledCheckArea>{isCheck && <CheckIcon />}</StyledCheckArea>;
};

export default CheckArea;
